import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { bonusAgents } from '../../mocks/courses';
import SchemaOrg from '../../components/base/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const agentesSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Agentes de IA Especializados para Professores',
  description:
    'Assistentes de inteligência artificial desenvolvidos para professores da educação básica: agentes para Ed. Infantil, Ensino Fundamental e Documentação Pedagógica da Educação Especial.',
  url: `${siteUrl}/agentes-ia`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@type': 'SoftwareApplication',
        name: 'Agente IA — Educação Infantil',
        applicationCategory: 'EducationalApplication',
        operatingSystem: 'Web',
        description:
          'Agente de IA especializado para professores da Educação Infantil, auxiliando na criação de planos, atividades lúdicas e materiais pedagógicos.',
        inLanguage: 'pt-BR',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'BRL', description: 'Incluso no curso' },
      },
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'SoftwareApplication',
        name: 'Agente IA — Ensino Fundamental',
        applicationCategory: 'EducationalApplication',
        operatingSystem: 'Web',
        description:
          'Agente de IA especializado para professores do Ensino Fundamental, criando planos de aula, avaliações e atividades alinhadas à BNCC.',
        inLanguage: 'pt-BR',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'BRL', description: 'Incluso no curso' },
      },
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@type': 'SoftwareApplication',
        name: 'Agente IA — Especialista em Documentação Pedagógica',
        applicationCategory: 'EducationalApplication',
        operatingSystem: 'Web',
        description:
          'Agente de IA criado para apoiar professores da educação básica na construção de documentos pedagógicos da educação especial: PDI, relatórios de AEE, laudos pedagógicos, planos individualizados e muito mais.',
        inLanguage: 'pt-BR',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'BRL', description: 'Incluso no curso' },
      },
    },
  ],
};

const docAgent = bonusAgents.find((a) => a.id === 'agente-documentacao')!;
const otherAgents = bonusAgents.filter((a) => a.id !== 'agente-documentacao');

const docExamples = [
  {
    icon: 'ri-user-heart-line',
    title: 'PDI',
    full: 'Plano de Desenvolvimento Individual',
    desc: 'Documento personalizado com metas, estratégias e adaptações para alunos com necessidades específicas.',
    color: 'bg-teal-50 text-teal-700 border-teal-200'
  },
  {
    icon: 'ri-hospital-line',
    title: 'Relatório de AEE',
    full: 'Atendimento Educacional Especializado',
    desc: 'Relatórios completos de acompanhamento do aluno no AEE, com evolução, recursos utilizados e próximas etapas.',
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  },
  {
    icon: 'ri-clipboard-line',
    title: 'Laudo Pedagógico',
    full: 'Avaliação pedagógica adaptada',
    desc: 'Laudos claros e éticos descrevendo o perfil de aprendizagem, sem substituir avaliação clínica.',
    color: 'bg-cyan-50 text-cyan-700 border-cyan-200'
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Plano Individualizado',
    full: 'Plano de Ensino Individualizado',
    desc: 'Planejamento pedagógico adaptado à realidade e ao ritmo de cada estudante com deficiência ou TEA.',
    color: 'bg-teal-50 text-teal-700 border-teal-200'
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Adequação Curricular',
    full: 'Flexibilização e adequação de currículo',
    desc: 'Sugestões de conteúdo, metodologia e avaliação adaptadas às necessidades do aluno.',
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Alinhamento Legal',
    full: 'LBI, LDBEN e legislação vigente',
    desc: 'Todos os documentos gerados consideram a Lei Brasileira de Inclusão e demais normativas educacionais.',
    color: 'bg-cyan-50 text-cyan-700 border-cyan-200'
  },
  {
    icon: 'ri-file-copy-2-line',
    title: 'Parecer Descritivo',
    full: 'Parecer de inclusão e acompanhamento',
    desc: 'Textos narrativos que descrevem o progresso do aluno de forma humanizada e profissional.',
    color: 'bg-teal-50 text-teal-700 border-teal-200'
  },
  {
    icon: 'ri-team-line',
    title: 'Registro Multidisciplinar',
    full: 'Acompanhamento terapêutico integrado',
    desc: 'Modelos de registro para articulação com equipe de saúde, família e gestão escolar.',
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
];

const OG_IMAGE = 'https://public.readdy.ai/ai/img_res/553dacf80cfda5ad7093220bbf5918de.jpg';
const OG_TITLE = 'Agentes de IA para Professores — PDI, AEE e Planos de Aula | ViaEducacaoCursos';
const OG_DESCRIPTION = '3 assistentes de IA criados para professores: Educação Infantil, Ensino Fundamental e Documentação Pedagógica. Gera PDI, relatórios de AEE, laudos adaptados e planos individualizados. Bônus incluso no curso por R$ 147,00.';

export default function AgentesIAPage() {
  const [activeTab, setActiveTab] = useState<string>('agente-documentacao');

  const handleCheckoutClick = () => {
    if (typeof (window as any).fbq === 'function') {
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Curso de IA para Professores',
        currency: 'BRL',
        value: 147.00
      });
    }
    window.open('https://pay.hotmart.com/W100719375C?off=w6t3o2lu', '_blank', 'noopener,noreferrer');
  };

  const pageUrl = `${siteUrl}/agentes-ia`;

  return (
    <div className="min-h-screen bg-white">
      {/* Open Graph + Twitter Card */}
      <title>{OG_TITLE}</title>
      <meta name="description" content={OG_DESCRIPTION} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={OG_TITLE} />
      <meta property="og:description" content={OG_DESCRIPTION} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Agentes de IA Especializados para Professores — ViaEducacaoCursos" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content="ViaEducacaoCursos" />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={OG_TITLE} />
      <meta name="twitter:description" content={OG_DESCRIPTION} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content="Agentes de IA Especializados para Professores — ViaEducacaoCursos" />

      <link rel="canonical" href={pageUrl} />

      <SchemaOrg id="agentes-ia" schema={agentesSchema} />
      <Navbar />
      <main>

        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 text-teal-700 text-sm font-semibold rounded-full mb-5">
              <i className="ri-robot-2-line w-4 h-4 flex items-center justify-center"></i>
              Bônus Exclusivos do Curso
            </span>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-5 leading-tight">
              Agentes de IA<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-emerald-500">
                Especializados para Professores
              </span>
            </h1>
            <p className="text-xl text-gray-500 max-w-3xl mx-auto">
              Assistentes de inteligência artificial desenvolvidos para cada contexto educacional — da educação infantil à documentação especial
            </p>
          </div>
        </section>

        {/* Tabs de seleção dos agentes */}
        <section className="py-6 border-b border-gray-100 sticky top-[72px] bg-white z-10">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex items-center gap-3 overflow-x-auto pb-1">
              {bonusAgents.map((agent) => (
                <button
                  key={agent.id}
                  onClick={() => setActiveTab(agent.id)}
                  className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer border ${
                    activeTab === agent.id
                      ? 'bg-teal-600 text-white border-teal-600 shadow-md'
                      : 'bg-white text-gray-600 border-gray-200 hover:border-teal-300 hover:text-teal-600'
                  }`}
                >
                  <i className={`${agent.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {agent.id === 'agente-infantil' && 'Ed. Infantil'}
                  {agent.id === 'agente-fundamental' && 'Ens. Fundamental'}
                  {agent.id === 'agente-documentacao' && 'Documentação Pedagógica'}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Cards dos agentes (Infantil + Fundamental) */}
        {activeTab !== 'agente-documentacao' && (
          <section className="py-20">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              {bonusAgents
                .filter((a) => a.id === activeTab)
                .map((agent) => (
                  <div key={agent.id} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
                    {/* Imagem + badge */}
                    <div className="relative rounded-3xl overflow-hidden h-96">
                      <img
                        src={agent.image}
                        alt={agent.title}
                        className="w-full h-full object-cover"
                      />
                      <span className="absolute top-6 left-6 px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm font-bold rounded-full flex items-center gap-2 shadow-lg">
                        <i className="ri-gift-fill"></i>
                        {agent.badge}
                      </span>
                    </div>
                    {/* Detalhes */}
                    <div>
                      <div className="flex items-center gap-4 mb-5">
                        <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-2xl">
                          <i className={`${agent.icon} text-3xl text-teal-600`}></i>
                        </div>
                        <div>
                          <p className="text-xs font-bold text-teal-600 uppercase tracking-widest mb-1">{agent.badge}</p>
                          <h2 className="text-2xl font-bold text-gray-900">{agent.title}</h2>
                        </div>
                      </div>
                      <p className="text-base text-gray-600 leading-relaxed mb-8">
                        {agent.description}
                      </p>
                      <h3 className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-4">O que esse agente gera:</h3>
                      <ul className="space-y-3">
                        {agent.capabilities?.map((cap, i) => (
                          <li key={i} className="flex items-center gap-3 text-gray-700 text-sm">
                            <span className="w-5 h-5 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                              <i className="ri-check-line text-teal-600 text-xs"></i>
                            </span>
                            {cap}
                          </li>
                        ))}
                      </ul>
                      <button
                        onClick={handleCheckoutClick}
                        className="w-full mt-8 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-bold rounded-full hover:shadow-lg hover:scale-[1.02] transition-all duration-300 whitespace-nowrap cursor-pointer"
                      >
                        Quero Acessar Este Agente
                      </button>
                      <div className="mt-3 p-4 bg-amber-50 border border-amber-200 rounded-2xl flex items-center gap-3">
                        <i className="ri-lock-2-line text-amber-600 text-xl w-6 h-6 flex items-center justify-center flex-shrink-0"></i>
                        <p className="text-sm text-amber-700">
                          <strong>Acesso incluso no curso.</strong> Disponível para todos os alunos matriculados.
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </section>
        )}

        {/* Seção destaque — Documentação Pedagógica */}
        {activeTab === 'agente-documentacao' && (
          <section className="py-20">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">

              {/* Header do agente */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
                <div className="relative rounded-3xl overflow-hidden h-96">
                  <img
                    src={docAgent.image}
                    alt={docAgent.title}
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute top-6 left-6 px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm font-bold rounded-full flex items-center gap-2 shadow-lg">
                    <i className="ri-gift-fill"></i>
                    {docAgent.badge}
                  </span>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                    <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-500/90 text-white text-xs font-bold rounded-full">
                      <i className="ri-shield-check-line"></i>
                      Alinhado à LBI · LDBEN · Resolução CNE/CEB 04/2009
                    </span>
                  </div>
                </div>
                <div>
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-2xl">
                      <i className="ri-file-text-line text-3xl text-teal-600"></i>
                    </div>
                    <div>
                      <p className="text-xs font-bold text-teal-600 uppercase tracking-widest mb-1">BÔNUS #4 — EXCLUSIVO</p>
                      <h2 className="text-2xl font-bold text-gray-900">{docAgent.title}</h2>
                    </div>
                  </div>
                  <p className="text-base text-gray-600 leading-relaxed mb-6">
                    {docAgent.description}
                  </p>
                  <div className="grid grid-cols-2 gap-3 mb-6">
                    {[
                      { icon: 'ri-heart-line', label: 'Ética e humanizado' },
                      { icon: 'ri-scales-3-line', label: 'Alinhado à legislação' },
                      { icon: 'ri-speed-line', label: 'Rápido e prático' },
                      { icon: 'ri-shield-check-line', label: 'Inclusivo e responsável' }
                    ].map((tag, i) => (
                      <div key={i} className="flex items-center gap-2 px-4 py-2.5 bg-teal-50 rounded-xl text-sm text-teal-700 font-medium border border-teal-100">
                        <i className={`${tag.icon} w-4 h-4 flex items-center justify-center`}></i>
                        {tag.label}
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={handleCheckoutClick}
                    className="w-full mt-2 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-bold rounded-full hover:shadow-lg hover:scale-[1.02] transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    Quero Acessar Este Agente
                  </button>
                  <div className="mt-3 p-4 bg-amber-50 border border-amber-200 rounded-2xl flex items-center gap-3">
                    <i className="ri-lock-2-line text-amber-600 text-xl w-6 h-6 flex items-center justify-center flex-shrink-0"></i>
                    <p className="text-sm text-amber-700">
                      <strong>Acesso incluso no curso.</strong> Disponível para todos os alunos matriculados.
                    </p>
                  </div>
                </div>
              </div>

              {/* Documentos que ele gera */}
              <div className="mb-16">
                <div className="text-center mb-10">
                  <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
                    Documentos que o Agente gera
                  </h2>
                  <p className="text-gray-500 max-w-2xl mx-auto">
                    De laudos a planos individualizados — tudo estruturado, ético e pronto para uso institucional
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                  {docExamples.map((doc, i) => (
                    <div
                      key={i}
                      className={`rounded-2xl border p-6 flex flex-col gap-3 hover:shadow-md transition-all duration-200 ${doc.color}`}
                    >
                      <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl shadow-sm">
                        <i className={`${doc.icon} text-xl`}></i>
                      </div>
                      <div>
                        <p className="text-xs font-bold uppercase tracking-wider opacity-70 mb-0.5">{doc.title}</p>
                        <h3 className="text-sm font-bold text-gray-900 leading-snug mb-2">{doc.full}</h3>
                        <p className="text-xs text-gray-600 leading-relaxed">{doc.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Como funciona — passo a passo */}
              <div className="bg-gray-50 rounded-3xl p-10 mb-16">
                <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Como usar o Agente de Documentação</h2>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                  {[
                    { step: '01', icon: 'ri-user-add-line', title: 'Informe o aluno', desc: 'Descreva o perfil do aluno, necessidades e diagnóstico (se houver).' },
                    { step: '02', icon: 'ri-file-list-3-line', title: 'Escolha o documento', desc: 'Selecione o tipo de documento: PDI, relatório de AEE, laudo, plano individualizado...' },
                    { step: '03', icon: 'ri-magic-line', title: 'Gere com IA', desc: 'O agente cria o documento completo, ético e alinhado à legislação brasileira.' },
                    { step: '04', icon: 'ri-edit-line', title: 'Revise e use', desc: 'Ajuste os detalhes e aplique diretamente no seu contexto escolar.' }
                  ].map((s, i) => (
                    <div key={i} className="flex flex-col items-center text-center gap-3">
                      <div className="relative">
                        <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-2xl">
                          <i className={`${s.icon} text-2xl text-teal-600`}></i>
                        </div>
                        <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-teal-600 text-white text-xs font-bold rounded-full">
                          {s.step}
                        </span>
                      </div>
                      <h3 className="text-base font-bold text-gray-900">{s.title}</h3>
                      <p className="text-sm text-gray-500 leading-relaxed">{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Aviso ético */}
              <div className="bg-teal-50 border border-teal-200 rounded-2xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                  <i className="ri-information-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-teal-800 mb-1">Uso ético e responsável</h4>
                  <p className="text-sm text-teal-700 leading-relaxed">
                    Os documentos gerados pelo agente são <strong>sugestões pedagógicas</strong> e devem ser revisados pelo professor responsável antes de qualquer uso formal ou institucional. O agente não substitui avaliação clínica, laudo médico ou parecer de especialistas de saúde. Seu uso deve respeitar o sigilo dos dados do aluno e as normas da LGPD.
                  </p>
                </div>
              </div>

            </div>
          </section>
        )}

        {/* Como funcionam os agentes */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-3">Como funcionam os Agentes de IA</h2>
              <p className="text-gray-500">Simples, rápido e criado para o dia a dia do professor</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { icon: 'ri-chat-3-line', color: 'bg-teal-100 text-teal-600', title: 'Conversação Natural', desc: 'Converse como se estivesse falando com um colega professor experiente. Sem comandos técnicos.' },
                { icon: 'ri-magic-line', color: 'bg-emerald-100 text-emerald-600', title: 'Prompts Especializados', desc: 'Biblioteca de prompts testados, otimizados para cada faixa etária, disciplina e contexto.' },
                { icon: 'ri-file-text-line', color: 'bg-cyan-100 text-cyan-600', title: 'Materiais Prontos', desc: 'Planos, atividades, avaliações e documentos pedagógicos gerados em segundos.' }
              ].map((item, i) => (
                <div key={i} className="bg-white rounded-2xl p-8">
                  <div className={`w-14 h-14 flex items-center justify-center ${item.color} rounded-2xl mb-5`}>
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="py-20 bg-gradient-to-br from-teal-600 to-emerald-600">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-4">
              Acesso Exclusivo para Alunos
            </h2>
            <p className="text-lg text-teal-100 mb-8 max-w-2xl mx-auto">
              Todos os agentes de IA são bônus inclusos no Curso de IA para Professores. Matricule-se e acesse tudo de uma vez.
            </p>
            <button
              onClick={handleCheckoutClick}
              className="inline-block px-10 py-4 bg-white text-teal-700 font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Quero me Inscrever no Curso
            </button>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
}
